const COMBINING_MARKS_REGEX = /[\u0300-\u036f]/g;
const WHITESPACE_REGEX = /\s+/g;
const NON_ID_CHARS_REGEX = /[^a-z0-9]+/g;

export const normalizeText = (value: string): string => {
  return value
    .trim()
    .normalize("NFKD")
    .replace(COMBINING_MARKS_REGEX, "")
    .replace(WHITESPACE_REGEX, " ")
    .toLowerCase();
};

export const normalizeId = (value: string): string => {
  const normalized = normalizeText(value).replace(NON_ID_CHARS_REGEX, "-").replace(/(^-|-$)/g, "");
  return normalized || "item";
};
